import { render, staticRenderFns } from "./nextPage.vue?vue&type=template&id=7a0faf0e&scoped=true&"
import script from "./nextPage.vue?vue&type=script&lang=js&"
export * from "./nextPage.vue?vue&type=script&lang=js&"
import style0 from "./nextPage.vue?vue&type=style&index=0&id=7a0faf0e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a0faf0e",
  null
  
)

export default component.exports